import {
  Measure
} from '../common/measure';

require('./stat-table.component.scss');

/*@ngInject*/
class StatTableController {
  constructor(
    $scope,
    $element,
    $timeout,
    CurrentModelService,
    CurrentFilterService,
    RouterService,
    LayoutService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.CurrentModelService = CurrentModelService;
    this.filterBar = CurrentFilterService.filterBar;
    this.router = RouterService;
    this.getMeasure = Measure.getMeasure;
    this.getMeasureLabel = Measure.getMeasureLabel;
    this.LayoutService = LayoutService;
  }

  drilldown(drill, cell, currMode) {
    const cuts = [...this.filterData.filter.filters];
    for (let i = 0; i < this.filterData.filter.drilldown.length; ++i) {
      const drilldown = this.filterData.filter.drilldown[i];
      const cut = this.CurrentModelService.model.getCellFilter(drilldown, cell);
      cuts.push(cut);
      if (drill === drilldown) {
        break;
      }
    }
    this.router.drilldownCuts(cuts, currMode && 'stat');
  }

  get isDownload() {
    return this.LayoutService.download;
  }

  get isFilters() {
    return this.filter.filters && this.filter.filters.length;
  }

  get appiedFilters() {
    if (!this.isFilters) return '';
    return this.filter.filters.map(f => {
      return `${this.CurrentModelService.model.getDrillLabel(f.dimension)
      }: ${f.label}`;
    });
  }

  get total() {
    return this.filterData && this.filterData.filterData.cells.length ? {
      cells: this.filterData.filterData.cells.length,
      name: this.getMeasureLabel(this.filter.measure),
      value: this.getMeasure(
        this.filterData.filterData.cells.reduce((sum, cell) => sum + cell[this.filter.measure], 0), this.filter.measure
      ),
    } : {};
  }

  barWidth(cell) {
    const measure = this.filterData.filter.measure;
    const width = (cell[measure] * 100 /
      this.filterData.filterData.maxMeasure) + '%';
    return width;
  }
}

export const StatTableComponent = {
  template: require('./stat-table.component.html'),
  bindings: {
    model: '<',
    filterData: '<',
    filter: '<',
  },
  controller: StatTableController,
};



// WEBPACK FOOTER //
// ./src/stat/stat-table.component.js